import { api } from "./api";

// Get all download statistics with filters
export const getDownloadStatistics = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "all" && value !== "") {
        if (key === "startDate" || key === "endDate") {
          queryParams.append(key, value.toISOString());
        } else {
          queryParams.append(key, value);
        }
      }
    });

    const response = await api.get(`/admin/download-statistics?${queryParams}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching download statistics:", error);
    throw error;
  }
};

// Get user-specific download statistics
export const getUserDownloadStatistics = async (userId, filters = {}) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "all" && value !== "") {
        if (key === "startDate" || key === "endDate") {
          queryParams.append(key, value.toISOString());
        } else {
          queryParams.append(key, value);
        }
      }
    });

    const response = await api.get(
      `/admin/user-download-statistics/${userId}?${queryParams}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user download statistics:", error);
    throw error;
  }
};

// Export download statistics as CSV
export const exportDownloadStatistics = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "all" && value !== "") {
        if (key === "startDate" || key === "endDate") {
          queryParams.append(key, value.toISOString());
        } else {
          queryParams.append(key, value);
        }
      }
    });

    const response = await api.get(
      `/admin/download-statistics/export?${queryParams}`,
      {
        responseType: "blob",
      }
    );

    // Create a download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `download-statistics-${new Date().toISOString().split("T")[0]}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting download statistics:", error);
    throw error;
  }
};

// Export user event logs
export const exportUserEventLogs = async (userId, filters = {}) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "all" && value !== "") {
        if (key === "startDate" || key === "endDate") {
          queryParams.append(key, value.toISOString());
        } else {
          queryParams.append(key, value);
        }
      }
    });

    // Use the api instance with proper auth headers
    const response = await api.get(
      `/admin/user-event-logs/${userId}/export?${queryParams}`,
      {
        responseType: "blob",
      }
    );

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = `user-${userId}-events-${
      new Date().toISOString().split("T")[0]
    }.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting user event logs:", error);
    throw error;
  }
};

// Export all event logs
export const exportAllEventLogs = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== "all" && value !== "") {
        if (key === "startDate" || key === "endDate") {
          queryParams.append(key, value.toISOString());
        } else {
          queryParams.append(key, value);
        }
      }
    });

    // Use the api instance with proper auth headers
    const response = await api.get(`/admin/event-logs/export?${queryParams}`, {
      responseType: "blob",
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = `event-logs-${new Date().toISOString().split("T")[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting all event logs:", error);
    throw error;
  }
};

const downloadStatisticsService = {
  getDownloadStatistics,
  getUserDownloadStatistics,
  exportDownloadStatistics,
  exportUserEventLogs,
  exportAllEventLogs,
};

export default downloadStatisticsService;
